export const FETCH_ACTIVE_INTEGRATIONS = {
  START: 'hardware/FETCH_ACTIVE_INTEGRATIONS_START',
  SUCCESS: 'hardware/FETCH_ACTIVE_INTEGRATIONS_SUCCESS',
  ERROR: 'hardware/FETCH_ACTIVE_INTEGRATIONS_ERROR',
};

export const SAVE_ACTIVE_INTEGRATIONS = {
  START: 'hardware/SAVE_ACTIVE_INTEGRATIONS_START',
  SUCCESS: 'hardware/SAVE_ACTIVE_INTEGRATIONS_SUCCESS',
  ERROR: 'hardware/SAVE_ACTIVE_INTEGRATIONS_ERROR',
};
